import Controller from './Controller';
import type Report from '../checks/Report';
import { CEMC_State } from '../commands/metamodel';
import { Combined_DeleteState } from '../commands/combined';
import type { IModelVersion } from './Controller';
import type { OrId } from '../commands/types';
import type { IState } from '../../stores/model/metamodel/state';

/**
 * Controller to edit a state of an FSM
 */
export default class EditStateController extends Controller {
  objectTypeId: string;
  fsmId: string;

  constructor(modelVersion: IModelVersion, objectTypeId: string, fsmId: string) {
    super(modelVersion);
    this.objectTypeId = objectTypeId;
    this.fsmId = fsmId;
  }

  async editState(id: OrId<IState>, name: string): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_State(model, this.objectTypeId, this.fsmId, id, name);
      return checks;
    });
  }

  async deleteState(id: OrId<IState>): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_DeleteState(model, this.objectTypeId, this.fsmId, id);
      return checks;
    });
  }
}
